import { render, staticRenderFns } from "./ScenesV1.vue?vue&type=template&id=05465a82&scoped=true&"
import script from "./ScenesV1.vue?vue&type=script&lang=js&"
export * from "./ScenesV1.vue?vue&type=script&lang=js&"
import style0 from "./ScenesV1.vue?vue&type=style&index=0&id=05465a82&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05465a82",
  null
  
)

export default component.exports